var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-container',[_c('el-header',{attrs:{"height":"70px"}},[_c('Header',{attrs:{"count":_vm.count}})],1),_c('el-container',[_c('el-aside',{attrs:{"width":"200px"}},[_c('sidebar')],1),_c('el-main',[_c('app-main',{staticClass:"appmain",on:{"getNoiceNum":_vm.getNoiceNum}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }